import React, { useRef, useEffect, useMemo, useState } from 'react';
import DataGrid, { Column } from 'devextreme-react/data-grid';
import { Item as TabItem } from "devextreme-react/tab-panel";
import Form, { GroupItem, SimpleItem, Label, ButtonItem, FormRef } from "devextreme-react/form";
import Guid from "../../models/Guid";
import IEnregistrement from '../../models/IEnregistrement';
import { FormListBase, FormListBaseTab, FormListBaseGrid, FormListBaseToolbar } from '../base';
import useCustomDataSource, { IFormBaseDataSourceOptions, Mode } from "../../hooks/useCustomDataSource";
import FormSysteme from '../../components/forms/form-systeme';
import { Button, RadioGroup, TextBox } from 'devextreme-react';
import useLookUpBase from '../../components/selectbox/LookupBase';
import GestionFolios from '../gestion-folios/gestion-folios';
import useApi from '../../hooks/useApi';
import GestionPosteEnregistrement from '../gestion-poste-enregistrement/gestion-poste-enregistrement';
import GestionInstitutionsFinancieres from '../gestion-institutions-financieres/gestion-institutions-financieres';

interface IConfigurationComptabiliteProps {
  isModeSelection?: boolean,
}

export default function ConfigurationComptabilite({ isModeSelection }: IConfigurationComptabiliteProps) {
  const enregistrementFormDataSource = useCustomDataSource<any, any>({ path: "enregistrement", primaryKey: "idEnregistrementEntete" });
  const { setMainForm, selectedDataRow: selectedEnregistrement, setIsFieldModifier, setSelectedDataRow, mode, setMode, isFieldModifier, onFieldDataChanged } = enregistrementFormDataSource;
  const { editorOptions: depotsClientsEditorOption, PopupGestion: PopupGestionFolios } = useLookUpBase({ isModeModifier: mode !== Mode.Lecture, controllerName: 'depot', setDataRow: () => setDataRow("idDepot"), showClear: mode !== Mode.Lecture, width: '35%', titre: 'Gestionnaire des folios' });
  const { editorOptions: institutionsEditorOption, PopupGestion: PopupGestionInstitutions } = useLookUpBase({ isModeModifier: mode !== Mode.Lecture, controllerName: 'institutionFinanciere', setDataRow: () => setDataRow("idInstitutionFinanciere"), showClear: mode !== Mode.Lecture, width: '35%', titre: 'Gestionnaire des folios' });
  const { editorOptions: comptesRecevablesEditorOption, PopupGestion: PopupGestionComptesRecevables } = useLookUpBase({ isModeModifier: mode !== Mode.Lecture, controllerName: 'depot', setDataRow: () => setDataRow("idDepot"), showClear: mode !== Mode.Lecture, width: '30%', titre: 'Gestionnaire des folios' });
  const { editorOptions: fraisDeServicesEditorOption, PopupGestion: PopupGestionFraisDeServices } = useLookUpBase({ isModeModifier: mode !== Mode.Lecture, controllerName: 'depot', setDataRow: () => setDataRow("idDepot"), showClear: mode !== Mode.Lecture, width: '30%', titre: 'Gestionnaire des folios' });
  const { editorOptions: escomptesEditorOption, PopupGestion: PopupGestionEscomptes } = useLookUpBase({ isModeModifier: mode !== Mode.Lecture, controllerName: 'depot', setDataRow: () => setDataRow("idDepot"), showClear: mode !== Mode.Lecture, width: '30%', titre: 'Gestionnaire des folios' });
  const { editorOptions: taxesHebergementEditorOption, PopupGestion: PopupGestionTaxesHebergement } = useLookUpBase({ isModeModifier: mode !== Mode.Lecture, controllerName: 'depot', setDataRow: () => setDataRow("idDepot"), showClear: mode !== Mode.Lecture, width: '30%', titre: 'Gestionnaire des folios' });
  const { editorOptions: tpsEditorOption, PopupGestion: PopupGestionTps } = useLookUpBase({ isModeModifier: mode !== Mode.Lecture, controllerName: 'depot', setDataRow: () => setDataRow("idDepot"), showClear: mode !== Mode.Lecture, width: '30%', titre: 'Gestionnaire des folios' });
  const { editorOptions: tvqEditorOption, PopupGestion: PopupGestionTvq } = useLookUpBase({ isModeModifier: mode !== Mode.Lecture, controllerName: 'depot', setDataRow: () => setDataRow("idDepot"), showClear: mode !== Mode.Lecture, width: '30%', titre: 'Gestionnaire des folios' });
  const { editorOptions: posteEnregistrementEditorOption, PopupGestion: PopupGestionPosteEnregistrement } = useLookUpBase({ isModeModifier: mode !== Mode.Lecture, controllerName: 'depot', setDataRow: () => setDataRow("idDepot"), showClear: mode !== Mode.Lecture, width: '38%', titre: "Gestionnaires des postes d'enregistrement" });
  const formRef = useRef<FormRef>(null);
  const months = ["Janvier", "Février", "Mars", "Avril", "Mai", "Juin", "Juillet", "Août", "Septembre", "Octobre", "Novembre", "Décembre"];

  const [filePath, setFilePath] = useState<string>("");
  const fileInputRef = useRef<HTMLInputElement>(null);
  const handleButtonClick = () => {
    fileInputRef.current?.click();
  };
  const handleFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (event.target.files?.length) {
      const file = event.target.files[0];
      setFilePath(file.name);
    }
  };

  const [folderPath, setFolderPath] = useState("");
  const handleFolderSelect = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (event.target.files && event.target.files.length > 0) {

      const file = event.target.files[0];
      setFolderPath(file.webkitRelativePath.split("/")[0]);
    }
  };
  const triggerFileInput = () => {
    document.getElementById("folderInput")?.click();
  };

  const pickFolder = async () => {
    if ("showDirectoryPicker" in window) {
      try {
        const directoryHandle = await (window as any).showDirectoryPicker();
        setFolderPath(directoryHandle.name);
      } catch (error) {
        console.error("Folder selection cancelled", error);
      }
    } else {
      alert("Your browser does not support the Folder Picker API.");
    }
  };


  const {
    getData: getConfig,
  } = useApi('Configuration');

  useEffect(() => {
    try {
      // const names = 'MOIS_DEBUT_ANNEE_FISCALE,FORMAT_TYPE_CHEQUES,FORMAT_DATE_CHEQUES,FOLIO_DEPOT_CLIENT,FOLIO_ESCOMPTES,FOLIO_COMPTE_RECEVABLE,FOLIO_FRAIS_SERVICES,FOLIO_ESCOMPTES,FOLIO_TAXE_HEBERGEMENT,FOLIO_TPS,FOLIO_TVQ,LOGICIEL_COMPTABLE,ID_POSTE_ENREGISTREMENT_WEB,UTILISATEUR_ATRIUM,MOT_PASSE_ATRIUM,FOLIO_COMPTE_A_PAYER,FOLIO_TPS_ACHATS,FOLIO_TVQ_ACHATS,FOLIO_ESCOMPTES_ACHATS,AFFICHER_COMPTE_A_PAYER_FOURNISSEUR,FOLIO_TAXES_RECEVOIR,FOLIO_BANQUE,INSTITUTION_FINANCIERE,NO_CENTRALE_TRAITEMENT_INFORMATIQUE_FICHIERS_DRD'
      // getConfig({customPath: `Configuration/${names}/Config`}).then((result) => {
      //     setSelectedDataRow(result)
      // }).catch((error) => {
      //     console.log(error)
      // })

      const names =
        'MOIS_DEBUT_ANNEE_FISCALE,FORMAT_TYPE_CHEQUES,FORMAT_DATE_CHEQUES,FOLIO_DEPOT_CLIENT,FOLIO_ESCOMPTES,FOLIO_COMPTE_RECEVABLE,FOLIO_FRAIS_SERVICES,FOLIO_TAXE_HEBERGEMENT,FOLIO_TPS,FOLIO_TVQ,LOGICIEL_COMPTABLE,ID_POSTE_ENREGISTREMENT_WEB,UTILISATEUR_ATRIUM,MOT_PASSE_ATRIUM,FOLIO_COMPTE_A_PAYER,FOLIO_TPS_ACHATS,FOLIO_TVQ_ACHATS,FOLIO_ESCOMPTES_ACHATS,AFFICHER_COMPTE_A_PAYER_FOURNISSEUR,FOLIO_TAXES_RECEVOIR,FOLIO_BANQUE,INSTITUTION_FINANCIERE,NO_CENTRALE_TRAITEMENT_INFORMATIQUE_FICHIERS_DRD';
      getConfig({ customPath: `Configuration/${encodeURIComponent(names)}/Config` })
        .then((result) => {
          setSelectedDataRow((prev: any) => {
            if (!result || typeof result !== 'object' || Array.isArray(result))
              return prev;
            return { ...prev, ...result };
          });
        })
        .catch((error) => {
          console.log(error);
        });
    } catch (error) {
    }
  }, [])

  const setDataRow = (e: string) => {
    setSelectedDataRow((prev: IEnregistrement) => (
      { ...prev, [e]: Guid.empty.toString() }
    ));
    setIsFieldModifier(true);
  }

  const monthPickerEditorOptions = useMemo(() => {
    return {
      dataSource: months, width: '20%',
      // value: months[selectedEnregistrement.MOIS_DEBUT_ANNEE_FISCALE],
      // onValueChanged: (e: any) => {
      //   const selectedMonthIndex = months.indexOf(e.value);
      //   if (selectedMonthIndex !== -1) {
      //     setSelectedDataRow((prev: IEnregistrement) => ({
      //       ...prev,
      //       MOIS_DEBUT_ANNEE_FISCALE: selectedMonthIndex.toString(),
      //     }));
      //     setIsFieldModifier(true);
      //   }
      // },
    }
  }, [selectedEnregistrement?.MOIS_DEBUT_ANNEE_FISCALE]);

  const fichierDRDEditorOptions = useMemo(() => {
    return {
      max: 99999,
      width: '10%',
      mask: "000000",
      useMaskedValue: true,
      onValueChanged: (e: any) => {
        let value = e.value || "";
        value = value.padEnd(6, "_");
        e.component.option("value", value);
      }
    }
  }, []);

  const logiciels = ['Acomba', 'Aucun', 'Avantage', 'Manisoft', 'ManisoftGestion', 'QuickBook'];
  const logicielComptableEditorOptions = useMemo(() => {
    return {
      width: '50%',
      items: logiciels
    }
  }, []);

  const priorities = ['Talon, Talon, Chèque', 'Talon, Chèque, Talon', 'Chèque, Talon, Talon'];
  const formatImpressionEditorOptions = useMemo(() => {
    return {
      items: priorities,
      layout: 'horizontal',
    }
  }, [priorities]);

  const annees = ['Jour Mois Année', 'Année Mois Jour'];
  const dateChequeEditorOptions = useMemo(() => {
    return {
      items: annees,
      layout: 'horizontal',
    }
  }, [annees]);

  const maxWidthEditorOptions = useMemo(() => {
    return {
      width: '50%'
    }
  }, []);

  const dossierEditorOptions = useMemo(() => {
    return {
      width: '50%',
      selectButtonText: "Sélectionner un dossier",
      labelText: "",
      multiple: true,
      uploadMode: "useButtons",
      allowedFileExtensions: ["*"],
      onValueChanged: (e: any) => {
        console.log("Files selected:", e.value);
      }
    }
  }, []);

  useEffect(() => {
    setMainForm(formRef.current?.instance());
  })

  useEffect(() => {
    if (mode !== Mode.Lecture) formRef.current?.instance().getEditor("description")?.focus();
  }, [mode])

  const onSelectionchanged = (item: any, e: string) => {
    setIsFieldModifier(true);
    setSelectedDataRow((prev: IEnregistrement) => {
      return { ...prev, [e]: item.id }
    })
  }

  return (
    <FormListBase data={enregistrementFormDataSource} hideList={true}>
      {/* <FormListBaseGrid dataSource={enregistrementFormDataSource.dataSource} onFocusedRowChanged={() => { setIsModeModify(false) }}      >
        <Column key={"grid-col-idEnregistrementEntete"} dataField={"idEnregistrementEntete"} caption="Description" allowHiding={false} />
      </FormListBaseGrid> */}
      <FormListBaseToolbar removeBlocked={true} headerText={`${selectedEnregistrement?.idEnregistrementEntete || ''}`} sauvegarderOptions={{ disabled: !isFieldModifier }} annulerOptions={{ disabled: !isFieldModifier }} effacerOptions={{ visible: false, disabled: !isFieldModifier }} />
      {!isModeSelection || isModeSelection && mode !== Mode.Lecture
        ? <FormListBaseTab>
          <PopupGestionFolios onSelectionchanged={(i) => onSelectionchanged(i, 'idcategorieclient')}>
            <GestionFolios isModeSelection={true} />
          </PopupGestionFolios>
          <PopupGestionInstitutions onSelectionchanged={(i) => onSelectionchanged(i, 'idinstitutionfinanciere')}>
            <GestionInstitutionsFinancieres isModeSelection={true} />
          </PopupGestionInstitutions>
          <PopupGestionComptesRecevables onSelectionchanged={(i) => onSelectionchanged(i, 'idcategorieclient')}>
            <GestionFolios isModeSelection={true} />
          </PopupGestionComptesRecevables>
          <PopupGestionFraisDeServices onSelectionchanged={(i) => onSelectionchanged(i, 'idcategorieclient')}>
            <GestionFolios isModeSelection={true} />
          </PopupGestionFraisDeServices>
          <PopupGestionEscomptes onSelectionchanged={(i) => onSelectionchanged(i, 'idcategorieclient')}>
            <GestionFolios isModeSelection={true} />
          </PopupGestionEscomptes>
          <PopupGestionTaxesHebergement onSelectionchanged={(i) => onSelectionchanged(i, 'idcategorieclient')}>
            <GestionFolios isModeSelection={true} />
          </PopupGestionTaxesHebergement>
          <PopupGestionTps onSelectionchanged={(i) => onSelectionchanged(i, 'idcategorieclient')}>
            <GestionFolios isModeSelection={true} />
          </PopupGestionTps>
          <PopupGestionTvq onSelectionchanged={(i) => onSelectionchanged(i, 'idcategorieclient')}>
            <GestionFolios isModeSelection={true} />
          </PopupGestionTvq>
          <PopupGestionPosteEnregistrement onSelectionchanged={(i) => onSelectionchanged(i, 'idcategorieclient')}>
            <GestionPosteEnregistrement isModeSelection={true} />
          </PopupGestionPosteEnregistrement>
          <TabItem title="Général">
            <div style={{ maxWidth: '80%' }}>
              <Form ref={formRef} readOnly={mode === Mode.Lecture} alignItemLabelsInAllGroups={true} formData={selectedEnregistrement || {} as IEnregistrement} className={"forms"} labelLocation={"left"} showColonAfterLabel={true} onFieldDataChanged={onFieldDataChanged}>
                <GroupItem caption={"Paramètres généraux"}>
                  <SimpleItem key={"frm-MOIS_DEBUT_ANNEE_FISCALE"} dataField={"MOIS_DEBUT_ANNEE_FISCALE"}
                    editorType={"dxSelectBox"}
                    editorOptions={monthPickerEditorOptions}
                  >
                    <Label text="Mois début année fiscale" />
                  </SimpleItem>
                  <SimpleItem
                    key="frm-FORMAT_TYPE_CHEQUES"
                    dataField="FORMAT_TYPE_CHEQUES"
                    editorType="dxRadioGroup"
                    editorOptions={formatImpressionEditorOptions}
                  >
                    <Label text="Format d'impression de chèques" />
                  </SimpleItem>
                  <SimpleItem
                    key="frm-FORMAT_DATE_CHEQUES"
                    dataField="FORMAT_DATE_CHEQUES"
                    editorType="dxRadioGroup"
                    editorOptions={dateChequeEditorOptions}
                  >
                    <Label text="Format de date sur les chèques" />
                  </SimpleItem>
                  <GroupItem caption='Comptes'>
                    <GroupItem colCount={2}>
                      <SimpleItem dataField={"FOLIO_DEPOT_CLIENT"} key={"frm-FOLIO_DEPOT_CLIENT"} editorType={"dxSelectBox"} editorOptions={depotsClientsEditorOption}>
                        <Label text={"Dépôts clients"} />
                      </SimpleItem>
                      <SimpleItem dataField={"FOLIO_ESCOMPTES"} key={"frm-FOLIO_ESCOMPTES"} editorType={"dxSelectBox"} editorOptions={depotsClientsEditorOption}>
                        <Label text={"Déboursés Restaurant"} />
                      </SimpleItem>
                    </GroupItem>
                    <GroupItem>
                      <SimpleItem dataField={"FOLIO_COMPTE_RECEVABLE"} key={"frm-FOLIO_COMPTE_RECEVABLE"} editorType={"dxSelectBox"} editorOptions={comptesRecevablesEditorOption}>
                        <Label text={"Comptes recevables"} />
                      </SimpleItem>
                      <SimpleItem dataField={"FOLIO_FRAIS_SERVICES"} key={"frm-FOLIO_FRAIS_SERVICES"} editorType={"dxSelectBox"} editorOptions={fraisDeServicesEditorOption}>
                        <Label text={"Frais de services"} />
                      </SimpleItem>
                      <SimpleItem dataField={"FOLIO_ESCOMPTES"} key={"frm-FOLIO_ESCOMPTES"} editorType={"dxSelectBox"} editorOptions={escomptesEditorOption}>
                        <Label text={"Escomptes"} />
                      </SimpleItem>
                      <SimpleItem dataField={"FOLIO_TAXE_HEBERGEMENT"} key={"frm-FOLIO_TAXE_HEBERGEMENT"} editorType={"dxSelectBox"} editorOptions={taxesHebergementEditorOption}>
                        <Label text={"Taxe d'hébergement"} />
                      </SimpleItem>
                      <SimpleItem dataField={"FOLIO_TPS"} key={"frm-FOLIO_TPS"} editorType={"dxSelectBox"} editorOptions={tpsEditorOption}>
                        <Label text={"TPS"} />
                      </SimpleItem>
                      <SimpleItem dataField={"FOLIO_TVQ"} key={"frm-FOLIO_TVQ"} editorType={"dxSelectBox"} editorOptions={tvqEditorOption}>
                        <Label text={"TVQ"} />
                      </SimpleItem>
                    </GroupItem>
                  </GroupItem>

                  <GroupItem caption='Exporation de données'>
                    <SimpleItem dataField={"LOGICIEL_COMPTABLE"} key={"frm-LOGICIEL_COMPTABLE"} editorType={"dxSelectBox"} editorOptions={logicielComptableEditorOptions}>
                      <Label text={"Logiciel comptable"} />
                    </SimpleItem>
                    <GroupItem alignItemLabels={false}>
                      <SimpleItem dataField={"ID_POSTE_ENREGISTREMENT_WEB"} key={"frm-ID_POSTE_ENREGISTREMENT_WEB"} editorType={"dxSelectBox"} editorOptions={posteEnregistrementEditorOption}>
                        <Label text={"Poste d'enregistrement pouvant faire les transferts au grand-livre"} />
                      </SimpleItem>
                    </GroupItem>
                    <SimpleItem dataField={"UTILISATEUR_ATRIUM"} key={"frm-UTILISATEUR_ATRIUM"} editorType={"dxTextBox"} editorOptions={maxWidthEditorOptions}>
                      <Label text={"Utilisateur"} />
                    </SimpleItem>
                    <SimpleItem dataField={"MOT_PASSE_ATRIUM"} key={"frm-MOT_PASSE_ATRIUM"} editorType={"dxTextBox"} editorOptions={maxWidthEditorOptions}>
                      <Label text={"Mot de passe"} />
                    </SimpleItem>
                    {/* <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                      <TextBox value={filePath} readOnly />
                      <Button text="..." onClick={triggerFileInput} />
                      <input
                        type="file"
                        ref={fileInputRef}
                        style={{ display: "none" }}
                        onChange={handleFolderSelect}
                      />
                    </div> */}
                    <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                      <TextBox value={folderPath} readOnly={true} width={300} />
                      <Button text="..." icon="ellipsis" onClick={pickFolder} />
                      <input
                        type="file"
                        id="folderInput"
                        // webkitdirectory="true"
                        // directory=""
                        style={{ display: "none" }}
                        onChange={handleFolderSelect}
                      />
                    </div>
                    <SimpleItem dataField={"dossier"} key={"frm-dossier"} editorType={"dxTextBox"} editorOptions={dossierEditorOptions}>
                      <Label text={"Dossier de la société"} />
                    </SimpleItem>
                    <SimpleItem dataField={"acomba"} key={"frm-acomba"} editorType={"dxTextBox"} editorOptions={dossierEditorOptions}>
                      <Label text={"Dossier de l'éxécutable Acomba"} />
                    </SimpleItem>
                  </GroupItem>
                </GroupItem>
              </Form>
            </div>
          </TabItem>
          <TabItem title="Fournisseurs">
            <Form ref={formRef} readOnly={mode === Mode.Lecture} alignItemLabelsInAllGroups={true} formData={selectedEnregistrement || {} as IEnregistrement} className={"forms"} labelLocation={"left"} showColonAfterLabel={true} onFieldDataChanged={onFieldDataChanged}>
              <GroupItem caption='Comptes'>
                <SimpleItem dataField={"FOLIO_COMPTE_A_PAYER"} key={"frm-FOLIO_COMPTE_A_PAYER"} editorType={"dxSelectBox"} editorOptions={depotsClientsEditorOption}>
                  <Label text={"Comptes a payer"} />
                </SimpleItem>
                <SimpleItem dataField={"FOLIO_TPS_ACHATS"} key={"frm-FOLIO_TPS_ACHATS"} editorType={"dxSelectBox"} editorOptions={depotsClientsEditorOption}>
                  <Label text={"TPS sur achats"} />
                </SimpleItem>
                <SimpleItem dataField={"FOLIO_TVQ_ACHATS"} key={"frm-FOLIO_TVQ_ACHATS"} editorType={"dxSelectBox"} editorOptions={depotsClientsEditorOption}>
                  <Label text={"TVQ sur achats"} />
                </SimpleItem>
                <SimpleItem dataField={"FOLIO_ESCOMPTES_ACHATS"} key={"frm-FOLIO_ESCOMPTES_ACHATS"} editorType={"dxSelectBox"} editorOptions={depotsClientsEditorOption}>
                  <Label text={"Escomptes sur achats"} />
                </SimpleItem>
                <SimpleItem key={"frm-AFFICHER_COMPTE_A_PAYER_FOURNISSEUR"} dataField={"AFFICHER_COMPTE_A_PAYER_FOURNISSEUR"} editorType={"dxCheckBox"} >
                  <Label text="Afficher le compte a payer dans les fournisseurs" />
                </SimpleItem>
              </GroupItem>
            </Form>
          </TabItem>
          <TabItem title="Grand-Livre">
            <Form ref={formRef} readOnly={mode === Mode.Lecture} alignItemLabelsInAllGroups={true} formData={selectedEnregistrement || {} as IEnregistrement} className={"forms"} labelLocation={"left"} showColonAfterLabel={true} onFieldDataChanged={onFieldDataChanged}>
              <GroupItem>
                <SimpleItem dataField={"FOLIO_TAXES_RECEVOIR"} key={"frm-FOLIO_TAXES_RECEVOIR"} editorType={"dxSelectBox"} editorOptions={depotsClientsEditorOption}>
                  <Label text={"Folio TPS/TVQ a recevoir"} />
                </SimpleItem>
                <SimpleItem dataField={"FOLIO_BANQUE"} key={"frm-FOLIO_BANQUE"} editorType={"dxSelectBox"} editorOptions={depotsClientsEditorOption}>
                  <Label text={"Folio de banque"} />
                </SimpleItem>
              </GroupItem>
            </Form>
          </TabItem>
          <TabItem title="Institution financière">
            <Form ref={formRef} readOnly={mode === Mode.Lecture} alignItemLabelsInAllGroups={true} formData={selectedEnregistrement || {} as IEnregistrement} className={"forms"} labelLocation={"left"} showColonAfterLabel={true} onFieldDataChanged={onFieldDataChanged}>
              <GroupItem caption='Paramètres généraux'>
                <SimpleItem dataField={"INSTITUTION_FINANCIERE"} key={"frm-INSTITUTION_FINANCIERE"} editorType={"dxSelectBox"} editorOptions={institutionsEditorOption}>
                  <Label text={"Institution financière"} />
                </SimpleItem>
                <SimpleItem dataField={"NO_CENTRALE_TRAITEMENT_INFORMATIQUE_FICHIERS_DRD"} key={"frm-NO_CENTRALE_TRAITEMENT_INFORMATIQUE_FICHIERS_DRD"} editorType={"dxTextBox"} editorOptions={fichierDRDEditorOptions}>
                  <Label text={"No. centrale de traitements informatiques de fichiers DRD"} />
                </SimpleItem>
              </GroupItem>
            </Form>
          </TabItem>
        </FormListBaseTab> : null}
    </FormListBase >
  );
}